import { ClassBaseService } from './../../services/class-base.service';
import { CollegeDetailService } from './../../services/college-detail.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-parent-child-summary',
  templateUrl: './parent-child-summary.component.html',
  styleUrls: ['./parent-child-summary.component.scss']
})
export class ParentChildSummaryComponent implements OnInit, OnDestroy {
  collegeListJson = [];
  assesmentListJson = [];
  tutoringListJson = [];
  collegeEvalutedListJson = [];
  collegePinnedListJson = [];
  pinnedLength = 0;
  evalutedLength = 0;
  parentChildData: any;
  nextStepListJson = [];
  partnerId: any;
  studentProfileData: any;
  pinnedCareersData = [];
  pinnedCollegesId: any;
  pinnedCollegesData = [];
  statusTutoring = false;
  tempList;
  colors = {};
  parentHomeDataSub: Subscription;
  loader = false;
  studentHideAssessment;
  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private _collegeDetailService: CollegeDetailService,
    private _classBaseService: ClassBaseService
  ) { }

  ngOnInit() {
    this.studentHideAssessment = JSON.parse(localStorage.getItem('studentHideAssessment'));
    this.partnerId = this._commonAuthService.getPartnerId();
    this.parentChildData = JSON.parse(localStorage.getItem('parentChildLocalData'));
    if (this.parentChildData) {
      this.getPageData();
    }
    this.parentHomeDataSub = this.commonDataSharedService.parentHomeData.subscribe((data: any) => {
      this.parentChildData = data;
      localStorage.setItem('parentChildLocalData', JSON.stringify(this.parentChildData));
      this.getPageData();
    })
  }

  getPageData() {
    this.getCollegeSummary();
    this.getNextStepsData();
    this.getTutoringSummary();
    this.getAssesmentSummary();
    this.getStudentProfileData();
    this.getTemperatureData();
  }

  getCollegeSummary() {
    if (this.parentChildData && this.parentChildData.studentUserId) {
      const collegeJson = {
        studentUserId: this.parentChildData.studentUserId,
        coachId: '0'
      };

      this._commonRequestResponseService.postWithHeader('student/studentprofile', collegeJson)
        .subscribe(
          (collegeListJson: any) => {
            this.studentHideAssessment = collegeListJson.hideAssessment;
            localStorage.setItem('classYearDescription', JSON.stringify(collegeListJson.personalInformation.classYearDescription));
            this.collegeListJson = collegeListJson.personalInformation;
            this.collegeEvalutedListJson = collegeListJson.evaluated;
            this.collegePinnedListJson = collegeListJson.pinned;
            if (this.collegePinnedListJson) {
              this.pinnedLength = this.collegePinnedListJson.length;
            }
            if (this.collegeEvalutedListJson) {
              this.evalutedLength = this.collegeEvalutedListJson.length;
            }
          },
          () => {
            this.notificationService.show('error', 'Error while fetching summary data');
          });
    }
  }

  getNextStepsData() {
    const input = {
      studentUserId: this.parentChildData.studentUserId
    };
    this._commonRequestResponseService.postWithHeader('student/nextsteps', input)
      .subscribe(
        (nextStepListJson: any) => {
          this.nextStepListJson = nextStepListJson.items;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching summary data');
        });
  }

  getTutoringSummary() {
    const collegeJson = {
      studentUserId: this.parentChildData.studentUserId
    };

    this._commonRequestResponseService.postWithHeader('student/tutoringsummary', collegeJson)
      .subscribe(
        (tutoringListJson: any) => {
          if (tutoringListJson && tutoringListJson.items) {
            this.tutoringListJson = tutoringListJson.items;
          }
        },
        () => {
          this.notificationService.show('error', 'Error while fetching licenses data');
        });
  }

  getAssesmentSummary() {
    const collegeJson = {
      studentUserId: this.parentChildData.studentUserId
    };

    this._commonRequestResponseService.postWithHeader('student/assessmentsummary', collegeJson)
      .subscribe(
        (assesmentListJson: any) => {
          this.assesmentListJson = assesmentListJson.items;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching licenses data');
        });
  }

  getStudentProfileData() {
    this.loader = true;
    if (this.parentChildData && this.parentChildData.studentUserId) {
      const inputJson = {
        studentUserId: this.parentChildData.studentUserId,
        coachId: '0',
        partnerId: this.partnerId
      };

      this._commonRequestResponseService.postWithHeader('student/studentprofile', inputJson)
        .subscribe(
          (data: any) => {
            this.loader = false;
            localStorage.setItem('classYearDescription', JSON.stringify(data.personalInformation.classYearDescription));
            if (data && data.personalInformation) {
              this.studentProfileData = data.personalInformation;
              this.pinnedCollegesId = data.personalInformation.pinnedCollegeIds;
              this.pinnedCareersData = data.personalInformation.pinnedCareer ? data.personalInformation.pinnedCareer.split('^') : [];
              this.statusTutoring = data.personalInformation.tutoringStatus;
              this.getParentCollgesNames();
            }
          },
          () => {
            this.loader = false;
            this.notificationService.show('error', 'Error while fetching data');
          });
    }
  }

  getParentCollgesNames() {
    const inputJson = {
      collegeIds: this.pinnedCollegesId
    };

    this._collegeDetailService.getCollegeNames(inputJson)
      .subscribe(
        (parentCollegeId) => {
          this.pinnedCollegesData = parentCollegeId.items;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching summary data');
        });
  }

  getTemperatureData() {
    this._classBaseService.getBrickTemperatureList(this.partnerId)
      .subscribe(
        (dataList: any) => {
          this.setBrickColorData(dataList);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching brick temp category');
        });
  }

  setBrickColorData(temperatures: any[]) {
    for (let i = 0; i < temperatures.length; i++) {
      if (temperatures[i].other) {
        this.colors[temperatures[i].value] = `linear-gradient(45deg,${temperatures[i].other.split(',')[0]},${temperatures[i].other.split(',')[1]})`;
      } else {
        this.colors[temperatures[i].value] = `linear-gradient(45deg,#A9A9A9,#A9A9A9)`;
      }
    }
  }


  ngOnDestroy() {
    this.parentHomeDataSub.unsubscribe();
  }
}
